class PresNettskjema {
  constructor() {}
  setup() {
    window.Nettskjema = (urlNettskjema) => (
      `
      <div class="vrtx-introduction show-introduction">
        <p>${i18n.nettskjemaHelptext}</p>
      </div>
      <div>
        
      </div>
      `
    )
  }
}
export default new PresNettskjema;
